import React from 'react';
import './TermsAndConditions.css';
import { useTranslation } from '../../hooks/useTranslation';

const TermsAndConditions = () => {
  const { t, direction } = useTranslation();

  return (
    <div className="terms-and-conditions " dir={direction}>

      {/* PAGE TITLE */}
      <div className='hero'>
        <h1 className='title-terms'>{t('terms.title')}</h1>
      </div>

      <div className="px-3 md:px-[2%] lg:px-[4%] xl:px-[4%] 2xl:px-[6%] points-terms pb-10 !space-y-3">

        {/* LAST UPDATED */}
        <p className='last-upd mt-4'>{t('terms.lastUpdated')}</p>

        {/* INTRODUCTION */}
        <h2>{t('terms.sections.introduction.title')}</h2>
        <p>{t('terms.sections.introduction.text')}</p>

        {/* 1. DEFINITIONS */}
        <h2>{t('terms.sections.definitions.title')}</h2>

        <h3>{t('terms.sections.definitions.items.platform.title')}</h3>
        <p>{t('terms.sections.definitions.items.platform.text')}</p>

        <h3>{t('terms.sections.definitions.items.user.title')}</h3>
        <p>{t('terms.sections.definitions.items.user.text')}</p>

        <h3>{t('terms.sections.definitions.items.provider.title')}</h3>
        <p>{t('terms.sections.definitions.items.provider.text')}</p>

        <h3>{t('terms.sections.definitions.items.customer.title')}</h3>
        <p>{t('terms.sections.definitions.items.customer.text')}</p>

        <h3>{t('terms.sections.definitions.items.invoice.title')}</h3>
        <p>{t('terms.sections.definitions.items.invoice.text')}</p>

        {/* 2. SERVICES PROVIDED */}
        <h2>{t('terms.sections.services.title')}</h2>

        <h3>{t('terms.sections.services.items.platformServices.title')}</h3>
        <ol>
          <li>{t('terms.sections.services.items.platformServices.point1')}</li>
          <li>{t('terms.sections.services.items.platformServices.point2')}</li>
          <li>{t('terms.sections.services.items.platformServices.point3')}</li>
          <li>{t('terms.sections.services.items.platformServices.point4')}</li>
          <li>{t('terms.sections.services.items.platformServices.point5')}</li>
        </ol>

        <h3>{t('terms.sections.services.items.scope.title')}</h3>
        <ul>
          <li>{t('terms.sections.services.items.scope.point1')}</li>
          <li>{t('terms.sections.services.items.scope.point2')}</li>
          <li>{t('terms.sections.services.items.scope.point3')}</li>
          <li>{t('terms.sections.services.items.scope.point4')}</li>
          <li>{t('terms.sections.services.items.scope.point5')}</li>
        </ul>

        {/* 3. TERMS OF USE */}
        <h2>{t('terms.sections.termsOfUse.title')}</h2>

        <h3>{t('terms.sections.termsOfUse.items.eligibility.title')}</h3>
        <ul>
          <li>{t('terms.sections.termsOfUse.items.eligibility.point1')}</li>
          <li>{t('terms.sections.termsOfUse.items.eligibility.point2')}</li>
          <li>{t('terms.sections.termsOfUse.items.eligibility.point3')}</li>
        </ul>

        <h3>{t('terms.sections.termsOfUse.items.responsibility.title')}</h3>
        <ul>
          <li>{t('terms.sections.termsOfUse.items.responsibility.point1')}</li>
          <li>{t('terms.sections.termsOfUse.items.responsibility.point2')}</li>
          <li>{t('terms.sections.termsOfUse.items.responsibility.point3')}</li>
          <li>{t('terms.sections.termsOfUse.items.responsibility.point4')}</li>
        </ul>

        <h3>{t('terms.sections.termsOfUse.items.prohibited.title')}</h3>
        <ul>
          <li>{t('terms.sections.termsOfUse.items.prohibited.point1')}</li>
          <li>{t('terms.sections.termsOfUse.items.prohibited.point2')}</li>
          <li>{t('terms.sections.termsOfUse.items.prohibited.point3')}</li>
          <li>{t('terms.sections.termsOfUse.items.prohibited.point4')}</li>
          <li>{t('terms.sections.termsOfUse.items.prohibited.point5')}</li>
        </ul>

        {/* 4. INVOICES & PAYMENT */}
        <h2>{t('terms.sections.payment.title')}</h2>

        <h3>{t('terms.sections.payment.items.invoices.title')}</h3>
        <ul>
          <li>{t('terms.sections.payment.items.invoices.point1')}</li>
          <li>{t('terms.sections.payment.items.invoices.point2')}</li>
          <li>{t('terms.sections.payment.items.invoices.point3')}</li>
          <li>{t('terms.sections.payment.items.invoices.point4')}</li>
          <li>{t('terms.sections.payment.items.invoices.point5')}</li>
        </ul>

        <h3>{t('terms.sections.payment.items.methods.title')}</h3>
        <ul>
          <li>{t('terms.sections.payment.items.methods.point1')}</li>
          <li>{t('terms.sections.payment.items.methods.point2')}</li>
          <li>{t('terms.sections.payment.items.methods.point3')}</li>
          <li>{t('terms.sections.payment.items.methods.point4')}</li>
        </ul>

        <h3>{t('terms.sections.payment.items.policy.title')}</h3>
        <ul>
          <li>{t('terms.sections.payment.items.policy.point1')}</li>
          <li>{t('terms.sections.payment.items.policy.point2')}</li>
          <li>{t('terms.sections.payment.items.policy.point3')}</li>
          <li>{t('terms.sections.payment.items.policy.point4')}</li>
        </ul>

        <h3>{t('terms.sections.payment.items.fees.title')}</h3>
        <ul>
          <li>{t('terms.sections.payment.items.fees.point1')}</li>
          <li>{t('terms.sections.payment.items.fees.point2')}</li>
          <li>{t('terms.sections.payment.items.fees.point3')}</li>
        </ul>

        {/* 5. CANCELLATION */}
        <h2>{t('terms.sections.cancellation.title')}</h2>

        <h3>{t('terms.sections.cancellation.items.customer.title')}</h3>
        <ul>
          <li>{t('terms.sections.cancellation.items.customer.point1')}</li>
          <li>{t('terms.sections.cancellation.items.customer.point2')}</li>
          <li>{t('terms.sections.cancellation.items.customer.point3')}</li>
        </ul>

        <h3>{t('terms.sections.cancellation.items.provider.title')}</h3>
        <ul>
          <li>{t('terms.sections.cancellation.items.provider.point1')}</li>
          <li>{t('terms.sections.cancellation.items.provider.point2')}</li>
        </ul>

        <h3>{t('terms.sections.cancellation.items.platform.title')}</h3>
        <ul>
          <li>{t('terms.sections.cancellation.items.platform.point1')}</li>
        </ul>

        {/* 6. LIABILITY */}
        <h2>{t('terms.sections.liability.title')}</h2>

        <h3>{t('terms.sections.liability.items.warranty.title')}</h3>
        <ul>
          <li>{t('terms.sections.liability.items.warranty.point1')}</li>
          <li>{t('terms.sections.liability.items.warranty.point2')}</li>
          <li>{t('terms.sections.liability.items.warranty.point3')}</li>
        </ul>

        <h3>{t('terms.sections.liability.items.limitation.title')}</h3>
        <ul>
          <li>{t('terms.sections.liability.items.limitation.point1')}</li>
          <li>{t('terms.sections.liability.items.limitation.point2')}</li>
          <li>{t('terms.sections.liability.items.limitation.point3')}</li>
        </ul>

        <h3>{t('terms.sections.liability.items.disclaimer.title')}</h3>
        <ul>
          <li>{t('terms.sections.liability.items.disclaimer.point1')}</li>
          <li>{t('terms.sections.liability.items.disclaimer.point2')}</li>
          <li>{t('terms.sections.liability.items.disclaimer.point3')}</li>
          <li>{t('terms.sections.liability.items.disclaimer.point4')}</li>
        </ul>

        {/* 7. DATA PROTECTION */}
        <h2>{t('terms.sections.privacy.title')}</h2>

        <h3>{t('terms.sections.privacy.items.collection.title')}</h3>
        <ul>
          <li>{t('terms.sections.privacy.items.collection.point1')}</li>
          <li>{t('terms.sections.privacy.items.collection.point2')}</li>
          <li>{t('terms.sections.privacy.items.collection.point3')}</li>
        </ul>

        <h3>{t('terms.sections.privacy.items.usage.title')}</h3>
        <ul>
          <li>{t('terms.sections.privacy.items.usage.point1')}</li>
          <li>{t('terms.sections.privacy.items.usage.point2')}</li>
          <li>{t('terms.sections.privacy.items.usage.point3')}</li>
          <li>{t('terms.sections.privacy.items.usage.point4')}</li>
        </ul>

        <h3>{t('terms.sections.privacy.items.protection.title')}</h3>
        <ul>
          <li>{t('terms.sections.privacy.items.protection.point1')}</li>
          <li>{t('terms.sections.privacy.items.protection.point2')}</li>
          <li>{t('terms.sections.privacy.items.protection.point3')}</li>
        </ul>

        <h3>{t('terms.sections.privacy.items.rights.title')}</h3>
        <ul>
          <li>{t('terms.sections.privacy.items.rights.point1')}</li>
          <li>{t('terms.sections.privacy.items.rights.point2')}</li>
          <li>{t('terms.sections.privacy.items.rights.point3')}</li>
          <li>{t('terms.sections.privacy.items.rights.point4')}</li>
        </ul>

        {/* 8. INTELLECTUAL PROPERTY */}
        <h2>{t('terms.sections.intellectual.title')}</h2>

        <h3>{t('terms.sections.intellectual.items.platformContent.title')}</h3>
        <p>{t('terms.sections.intellectual.items.platformContent.text')}</p>

        <h3>{t('terms.sections.intellectual.items.userContent.title')}</h3>
        <ul>
          <li>{t('terms.sections.intellectual.items.userContent.point1')}</li>
          <li>{t('terms.sections.intellectual.items.userContent.point2')}</li>
        </ul>

        <h3>{t('terms.sections.intellectual.items.restrictions.title')}</h3>
        <ul>
          <li>{t('terms.sections.intellectual.items.restrictions.point1')}</li>
          <li>{t('terms.sections.intellectual.items.restrictions.point2')}</li>
          <li>{t('terms.sections.intellectual.items.restrictions.point3')}</li>
        </ul>

        {/* 9. LEGAL OBLIGATIONS */}
        <h2>{t('terms.sections.legal.title')}</h2>

        <h3>{t('terms.sections.legal.items.compliance.title')}</h3>
        <ul>
          <li>{t('terms.sections.legal.items.compliance.point1')}</li>
          <li>{t('terms.sections.legal.items.compliance.point2')}</li>
          <li>{t('terms.sections.legal.items.compliance.point3')}</li>
        </ul>

        <h3>{t('terms.sections.legal.items.taxes.title')}</h3>
        <ul>
          <li>{t('terms.sections.legal.items.taxes.point1')}</li>
          <li>{t('terms.sections.legal.items.taxes.point2')}</li>
        </ul>

        <h3>{t('terms.sections.legal.items.licenses.title')}</h3>
        <ul>
          <li>{t('terms.sections.legal.items.licenses.point1')}</li>
          <li>{t('terms.sections.legal.items.licenses.point2')}</li>
        </ul>

        {/* 10. AMENDMENTS */}
        <h2>{t('terms.sections.amendments.title')}</h2>

        <h3>{t('terms.sections.amendments.items.rights.title')}</h3>
        <ul>
          <li>{t('terms.sections.amendments.items.rights.point1')}</li>
          <li>{t('terms.sections.amendments.items.rights.point2')}</li>
          <li>{t('terms.sections.amendments.items.rights.point3')}</li>
        </ul>

        <h3>{t('terms.sections.amendments.items.notice.title')}</h3>
        <ul>
          <li>{t('terms.sections.amendments.items.notice.point1')}</li>
          <li>{t('terms.sections.amendments.items.notice.point2')}</li>
        </ul>

        {/* 11. TERMINATION */}
        <h2>{t('terms.sections.termination.title')}</h2>

        <h3>{t('terms.sections.termination.items.service.title')}</h3>
        <ul>
          <li>{t('terms.sections.termination.items.service.point1')}</li>
          <li>{t('terms.sections.termination.items.service.point2')}</li>
          <li>{t('terms.sections.termination.items.service.point3')}</li>
          <li>{t('terms.sections.termination.items.service.point4')}</li>
        </ul>

        <h3>{t('terms.sections.termination.items.suspension.title')}</h3>
        <ul>
          <li>{t('terms.sections.termination.items.suspension.point1')}</li>
          <li>{t('terms.sections.termination.items.suspension.point2')}</li>
          <li>{t('terms.sections.termination.items.suspension.point3')}</li>
        </ul>

        {/* 12. CONTACT */}
        <h2>{t('terms.sections.contact.title')}</h2>

        <h3>{t('terms.sections.contact.items.channels.title')}</h3>
        <ul>
          <li>{t('terms.sections.contact.items.channels.point1')}</li>
          <li>{t('terms.sections.contact.items.channels.point2')}</li>
          <li>{t('terms.sections.contact.items.channels.point3')}</li>
          <li>{t('terms.sections.contact.items.channels.point4')}</li>
        </ul>

        <h3>{t('terms.sections.contact.items.support.title')}</h3>
        <ul>
          <li>{t('terms.sections.contact.items.support.point1')}</li>
          <li>{t('terms.sections.contact.items.support.point2')}</li>
        </ul>

        <h3>{t('terms.sections.contact.items.disputes.title')}</h3>
        <ul>
          <li>{t('terms.sections.contact.items.disputes.point1')}</li>
          <li>{t('terms.sections.contact.items.disputes.point2')}</li>
        </ul>

        {/* 13. GOVERNING LAW */}
        <h2>{t('terms.sections.law.title')}</h2>
        <p>{t('terms.sections.law.text')}</p>

        {/* 14. FINAL PROVISIONS */}
        <h2>{t('terms.sections.final.title')}</h2>

        <h3>{t('terms.sections.final.items.agreement.title')}</h3>
        <p>{t('terms.sections.final.items.agreement.text')}</p>

        <h3>{t('terms.sections.final.items.severability.title')}</h3>
        <p>{t('terms.sections.final.items.severability.text')}</p>

        <h3>{t('terms.sections.final.items.waiver.title')}</h3>
        <p>{t('terms.sections.final.items.waiver.text')}</p>

        <h3>{t('terms.sections.final.items.notices.title')}</h3>
        <p>{t('terms.sections.final.items.notices.text')}</p>

        {/* 15. ACCEPTANCE */}
        <h2>{t('terms.sections.acceptance.title')}</h2>
        <p>{t('terms.sections.acceptance.text')}</p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
